<template>
  <v-container fluid>
    <h2>Returns and Exchanges</h2>
    <p>
      We want you to be completely satisfied with your purchase; If you aren't, send us an email and we'll do our best to make things right.
    </p>
    <p>
      <ol>
        <li>
          Items must be returned in the same condition they arrived in - used items may not be returned.
        </li>
        <li>
          Items must be returned within <b>30 days</b> from the delivery date.
        </li>
        <li>
          Items can be returned for Store Credit only.
        </li>
        <li>
          If the item arrives damaged or defective: we will pay for shipping.
        </li>
        <li>
          If the item is not damaged or defective: you can still return it, but you are responsible for shipping.
        </li>
      </ol>
    </p>
    <p>
      All sales on <b>patches</b> are final, but, if you received a damaged or defective patch, send us an email and we'll get a new one to you at no cost to you.
    </p>
    <p>
      To initiate a return, please send an email to <a href="mailto:memerhats@gmail.com">memerhats@gmail.com</a> with RETURN and your ORDER NUMBER in the subject line.
    </p>
  </v-container>
</template>

<script>
export default {
  name: 'ReturnsPolicy',
  data() {
    return {
      //
    };
  },
};
</script>

<style lang="stylus" scoped>
@require('../../stylus/base')
//
</style>
